import { CryptoCurrencyID } from "../constants";
import * as ratesApi from "@/api/rates";
import { useQuery } from "@tanstack/react-query";

const useCurrencyRate = (currencyId = CryptoCurrencyID.ETH) => {
  const getCurrencyRate = () => {
    switch (currencyId) {
      case CryptoCurrencyID.ETH:
        return ratesApi.getEtherRate();
      case CryptoCurrencyID.WETH:
        return ratesApi.getEtherRate();
      case CryptoCurrencyID.POL:
        return ratesApi.getPolRate();
      case CryptoCurrencyID.WPOL:
        return ratesApi.getWPolRate();
      case CryptoCurrencyID.TURBO:
        return ratesApi.getTurboRate();
      case CryptoCurrencyID.USDT:
        return ratesApi.getUsdtRate();
      default:
        new Error("Invalid currency id!");
    }
  };

  return useQuery({
    queryKey: [`${currencyId}-rate`],
    queryFn: () => getCurrencyRate(),
    staleTime: 60 * 1000,
  });
};

export default useCurrencyRate;
